// libs
import isEmpty from 'lodash/isEmpty';
import escapeRegExp from 'lodash/escapeRegExp';

// types
import { IBrandCategory, IBrandItem } from 'shared/api/mega-menu-v2/types';
import { IBucketizedBrands } from './types';

export const DEFAULT_INITIALS = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const sortByName = (a: IBrandItem, b: IBrandItem) => {
  const aName = a.name.toLowerCase();
  const bName = b.name.toLowerCase();

  if (aName < bName) {
    return -1;
  }
  if (aName > bName) {
    return 1;
  }
  return 0;
};

export const getAllBrands = (brandsData: IBrandCategory[]): IBrandItem[] => {
  let concatenatedBrands: IBrandItem[] = [];
  let brandIds: Set<string | number> = new Set();
  let allBrands: IBrandItem[] = [];

  brandsData.forEach((brandCategory) => {
    if (!isEmpty(brandCategory.children_data)) {
      concatenatedBrands = concatenatedBrands.concat(brandCategory.children_data);
    }
  });

  // remove duplicates in the new array
  concatenatedBrands.forEach((brandItem) => {
    if (!brandIds.has(brandItem.id)) {
      allBrands.push(brandItem);
      brandIds.add(brandItem.id);
    }
  });

  // return alphabetically sorted data
  return allBrands.sort(sortByName);
};

export const getBucketizedBrands = (brandsData: IBrandItem[]): IBucketizedBrands => {
  return brandsData.reduce((bucket: IBucketizedBrands, brand) => {
    let char: string = brand.name ? brand.name.substring(0, 1).toUpperCase() : DEFAULT_INITIALS[0];

    if (!DEFAULT_INITIALS.includes(char)) {
      char = DEFAULT_INITIALS[0];
    }

    if (bucket[char] === undefined) {
      bucket[char] = [];
    }

    bucket[char].push(brand);
    return bucket;
  }, {});
};

export const getFilteredBrands = (brands: IBrandItem[], filterText: string) => {
  if (filterText.trim().length === 0) {
    return brands;
  }

  const filterRegExp = new RegExp(`${escapeRegExp(filterText)}`, 'i');

  return brands.filter((brand: { name: string }) => filterRegExp.test(brand.name));
};
